module.exports = "/images/cinema.svg?7c3df15be158cc8600a1374d3e67faa9";